import { connect } from "react-redux";
import { selectCurrentModalWithType } from "../../selectors/selectCurrentModalWithType";
import { componentWithProps } from "../generic/componentWithProps";
import { TypeModal } from "../modals/TypeModal";
export var MenuManagerDOM = connect(selectCurrentModalWithType(TypeModal.Menu))(componentWithProps);



//////////////////
// WEBPACK FOOTER
// ./src/features/menus/MenuManagerDOM.tsx
// module id = 1368
// module chunks = 3